/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type GetBrandProfilesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetBrandProfilesQuery = {
    __typename: 'Query';
    brandProfiles: Array<{
        __typename: 'BrandProfiles';
        displayName: string;
        logos: Array<{ __typename: 'BrandLogo'; previewUrl: string }>;
    }>;
};

export const GetBrandProfilesDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetBrandProfiles' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'brandProfiles' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'logos' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'previewUrl' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useGetBrandProfilesQuery__
 *
 * To run a query within a React component, call `useGetBrandProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandProfilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrandProfilesQuery(
    baseOptions?: Apollo.QueryHookOptions<GetBrandProfilesQuery, GetBrandProfilesQueryVariables>
) {
    return Apollo.useQuery<GetBrandProfilesQuery, GetBrandProfilesQueryVariables>(
        GetBrandProfilesDocument,
        baseOptions
    );
}
export function useGetBrandProfilesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetBrandProfilesQuery, GetBrandProfilesQueryVariables>
) {
    return Apollo.useLazyQuery<GetBrandProfilesQuery, GetBrandProfilesQueryVariables>(
        GetBrandProfilesDocument,
        baseOptions
    );
}
export type GetBrandProfilesQueryHookResult = ReturnType<typeof useGetBrandProfilesQuery>;
export type GetBrandProfilesLazyQueryHookResult = ReturnType<typeof useGetBrandProfilesLazyQuery>;
export type GetBrandProfilesQueryResult = Apollo.QueryResult<
    GetBrandProfilesQuery,
    GetBrandProfilesQueryVariables
>;
